module.exports = __webpack_public_path__ + "static/img/service5.sample1.a6e480d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service5.sample1.png
// module id = T8eE
// module chunks = 1